<template>
  <div class="field-repeating-group" :class="{ container: parent.Type !== PreApproveMe.fieldTypes.Group }">
    <div class="grid-form">
      <legend v-if="data.Text">
        <span><Localize :text="data.Text" /></span>
      </legend>
    </div>
    <template v-for="(field, index) in data.Body">
      <div :key="field.Id + (typeof field.RepeatIndex !== 'undefined' ? '__' + field.RepeatIndex : '')" class="repeating-group-item" :class="{ active: !field.AccordionClosed }">
        <div class="repeating-group-accordian">
          <div class="repeating-group-label" @mousedown="labelClick(field)">
            <span><Localize :text="getLabel(typeof field.RepeatIndex !== 'undefined' ? field.RepeatIndex : 'init')" /></span>
            <icon :icon="['fas', 'caret-down']" v-if="field.AccordionClosed" />
            <icon :icon="['fas', 'caret-left']" v-else />
          </div>
        </div>
        <div class="repeating-group-field" :class="{ added: index > 0 || (data.InitialFields || []).length === 0 }">
          <div class="repeating-group-remove" v-if="allowRemovePrompt(index)">
            <a href="#" @mousedown="removeItem(index, field)"><icon :icon="['fas', 'minus-circle']" /> <Localize :text="removePrompt" /></a>
          </div>
          <Field :data="field" :parent="data" :sectionid="sectionid" :pageid="pageid" @field:isvalid="evtValid" @field:isfocused="evtFocused" @field:value="evtValue" @field:change="evtChange($event, field, typeof field.RepeatIndex !== 'undefined' ? field.RepeatIndex : 'init')" @field:delete="evtDelete" />
        </div>
      </div>
    </template>
    <div class="repeating-group-add-link" v-if="allowListExpansionPrompt()">
      <a href="#" @click.prevent @mousedown="addItem"><Localize :text="addPrompt" /></a>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import PreApproveMe from '@/services/PreApproveMe.js'
import Localize from '@/components/Localize.vue'
import { DateTime, Interval } from 'luxon'

export default {
  name: 'FieldRepeatingGroup',
  components: {
    Localize
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe,
      isValid: true,
      repeatIndex: 0,
      accordionLabels: {},
      internalTimeTracker: [],
      lastValidation: 0,
      validationTimer: 0
    }
  },
  computed: {
    addPrompt: function () {
      return "+Add " + this.data.ListExpansionPrompt
    },
    removePrompt: function () {
      return "Remove this " + this.data.ListExpansionPrompt
    }
  },
  methods: {
    validate: function(showAlert) {
      showAlert = showAlert === true ? true : false
      var minYears = 2

      if (Math.abs(new Date().getTime() - this.lastValidation) < 600) {
        if (this.validationTimer === 0)
          this.validationTimer = setTimeout(this.validate.bind(null, showAlert), 600)
        return
      }

      this.lastValidation = new Date().getTime()
      this.validationTimer = 0

      var messageType = null
      if (this.data.Id == 'smart1003_borrower_residences')
        messageType = 'residences'
      if (this.data.Id == 'smart1003_borrower_employers')
        messageType = 'employment'

      // Only do the special validation logic for residences and employers
      if (messageType === null) {
        if (!this.isValid) {
          this.$store.commit('setInputValid', {
            field: this.data,
            sectionid: this.sectionid,
            pageid: this.pageid
          })

          this.isValid = true
        }

        return
      }

      // Handling multiple current jobs? - Not going to do this for now, pending discussions
      var yearsCount = 0
      var monthsCount = 0
      var startCount = 0

      // Calculate counts
      for (var i = 0; i < this.internalTimeTracker.length; i++) {
        if (this.internalTimeTracker[i].BorrowerID !== this.$store.state.borrowerid)
          continue

/*
        if (this.internalTimeTracker[i].Start !== null) {
          var start = DateTime.fromFormat(this.internalTimeTracker[i].Start, 'LL/dd/yyyy')
          var end = DateTime.now()

          if (this.internalTimeTracker[i].End !== null)
            end = DateTime.fromFormat(this.internalTimeTracker[i].End, 'LL/dd/yyyy')

          if (!start.isValid)
            continue
          if (!end.isValid)
            end = DateTime.now()

          var interval = Interval.fromDateTimes(start, end)
          yearsCount += Math.abs(Math.floor(interval.length('years')))
          monthsCount += Math.abs(Math.round(interval.length('months')))
        }
*/
        if (this.internalTimeTracker[i].Start !== null) {
          var start = DateTime.fromFormat(this.internalTimeTracker[i].Start, 'LL/dd/yyyy')

          startCount = Math.max(startCount, DateTime.now().diff(start).as('months'))
        }
        else {
          if (this.internalTimeTracker[i].Years !== null)
            yearsCount += this.internalTimeTracker[i].Years * 1
          if (this.internalTimeTracker[i].Months !== null)
            monthsCount += this.internalTimeTracker[i].Months * 1
        }
      }

      //yearsCount += Math.floor(monthsCount / 12)
      //monthsCount = monthsCount % 12

      var totalMonths = Math.max(yearsCount * 12 + monthsCount, startCount)

      // Validation check passed     
      if (totalMonths === 0 || totalMonths >= minYears * 12) {
        //  remove extra items
        var removeIndexes = []

        // We always have initial fields, so hardcode skipping the first element
        for (i = 1; i < this.data.Body.length; i++) {
          var tracker = this.getTimeTrackerForId(this.data.Body[i].Id)

          if (!tracker.Years && !tracker.Months && !tracker.Start && !tracker.End)
            removeIndexes.push(i)
        }

        if (messageType === 'residences')
          for (var i = removeIndexes.length - 1; i >= 0; i--)
            this.removeItem(removeIndexes[i])

        if (!this.isValid) {
          this.$store.commit('setInputValid', {
            field: this.data,
            sectionid: this.sectionid,
            pageid: this.pageid
          })

          this.isValid = true
        }
      }
      // Validation check failed
      else {
        if (showAlert)
          this.$store.commit('openToast', {
            text: this.yearRequirementMessage(minYears, messageType),
            type: 'warning'
          })

        // Add item to end of list if the last item has years and months
        var hasBlank = false

        for (var i = 0; i < this.internalTimeTracker.length; i++) {
          if (this.internalTimeTracker[i].BorrowerID !== this.$store.state.borrowerid)
            continue

          hasBlank = hasBlank || (!this.internalTimeTracker[i].Years && !this.internalTimeTracker[i].Months && !this.internalTimeTracker[i].Start && !this.internalTimeTracker[i].End)
        }
        
        if (!hasBlank && messageType === 'residences')
          this.addItem()

        if (this.isValid) {
            this.$store.commit('setInputInvalid', {
              field: this.data,
              sectionid: this.sectionid,
              pageid: this.pageid
            })

          this.isValid = false
        }
      }
    },
    allowListExpansionPrompt: function() {
      if (!this.data.ListExpansionPrompt) return false
      if (this.data.Id == 'smart1003_borrower_residences')
        return false
      //else if (this.data.Id == 'smart1003_borrower_employers')
      //  return false
      return true
    },
    allowRemovePrompt: function (index) {
      if (this.data.Id == 'smart1003_borrower_residences')
        return false
      //if (this.data.Id == 'smart1003_borrower_employers')
      //  return false
      if (index == 0 && (this.data.InitialFields || []).length > 0)
        return false

      return true
    },
    addItem: function(ev, atIndex) {
      if (typeof atIndex !== 'number')
        atIndex = this.repeatIndex++

      let newFields = JSON.parse(JSON.stringify(this.data.SubsequentFields))
      for (let group_i = 0; group_i < newFields.length; group_i++) {
        newFields[group_i].RepeatIndex = atIndex
        newFields[group_i].Id = newFields[group_i].Id + '__' + atIndex
        if (newFields[group_i].Fields) {
          for (let row_i = 0; row_i < newFields[group_i].Fields.length; row_i++) {
            for (let field_i = 0; field_i < newFields[group_i].Fields[row_i].length; field_i++) {
              newFields[group_i].Fields[row_i][field_i].RepeatIndex = atIndex
              // This logic should probably be removed/changed
              // but is necessary at the moment
              newFields[group_i].Fields[row_i][field_i].Id = newFields[group_i].Fields[row_i][field_i].Id + '__' + atIndex

              // Ensure we have a tracker entry for the new item
              this.getTimeTrackerForId(newFields[group_i].Fields[row_i][field_i].Id)
            }
          }
        }
      }
      this.data.Body = [...this.data.Body, ...newFields]
    },
    removeItem: function(index, field) {
      var removed = this.data.Body.splice(index, 1)

      this.validate(true)
    },
    labelClick: function(field) {
      Vue.set(field, 'AccordionClosed', !(field.AccordionClosed || false))

      var vm = this
      vm.$root.$emit('slider:update')
      setTimeout(() => {
        vm.$root.$emit('slider:update')
      }, 100)
      setTimeout(() => {
        vm.$root.$emit('slider:update')
      }, 350)
    },
    firstField: function(field) {
      if (!field.Type && field.length > 0) return this.firstField(field[0])
      if (field.Body && field.Body.length > 0)
        return this.firstField(field.Body[0])
      if (field.Fields && field.Fields.length > 0)
        return this.firstField(field.Fields[0])
      return field
    },
    getLabel: function(key) {
      if (this.accordionLabels[key]) return this.accordionLabels[key]
      return ''
    },
    getTimeTrackerForId: function (id) {
      var index = -1
      
      var parts = id.split('__')
      if (parts.length > 1)
        index = parts[1] * 1

      if (isNaN(index))
        index = -1

      var tracking = null
      for (var i = 0; i < this.internalTimeTracker.length; i++)
        if (this.internalTimeTracker[i].BorrowerID === this.$store.state.borrowerid && this.internalTimeTracker[i].Index === index)
          tracking = this.internalTimeTracker[i]

      if (tracking === null)
      {
        tracking = { BorrowerID: this.$store.state.borrowerid, Index: index, Years: null, Months: null, Start: null, End: null }
        this.internalTimeTracker.push(tracking)
      }

      return tracking
    },

    evtValid: function($event) {},
    evtFocused: function($event) {},
    evtValue: function($event) {
      var tracking = this.getTimeTrackerForId($event.Id)

      var isNew = false
      if ($event.Id.indexOf('smart1003_borrower_employer_years') !== -1)
      {
        isNew = tracking.Years === null
        tracking.Years = $event.Value
        this.validate(isNew)
      }
      if ($event.Id.indexOf('smart1003_borrower_employer_months') !== -1)
      {
        isNew = tracking.Months === null
        tracking.Months = $event.Value
        this.validate(isNew)
      }
      if ($event.Id.indexOf('smart1003_borrower_employer_start') !== -1)
      {
        isNew = tracking.Start === null
        tracking.Start = $event.Value
        this.validate(isNew)
      }
      if ($event.Id.indexOf('smart1003_borrower_employer_end') !== -1)
      {
        isNew = tracking.End === null
        tracking.End = $event.Value
        this.validate(isNew)
      }
      if ($event.Id.indexOf('smart1003_borrower_residence_years') !== -1)
      {
        isNew = tracking.Years === null
        tracking.Years = $event.Value
        this.validate(isNew)
      }
      if ($event.Id.indexOf('smart1003_borrower_residence_months') !== -1)
      {
        isNew = tracking.Months === null
        tracking.Months = $event.Value
        this.validate(isNew)
      }
    },
    evtChange: function($event, field, key) {
      let ff = this.firstField(field)
      if (ff.Id == $event.Id || ff.Id + '__' + key == $event.Id) {
        this.$set(this.accordionLabels, key, $event.Value)
      }
    },
    evtDelete: function($event) {
      var tracking = this.getTimeTrackerForId($event.Id)

      this.internalTimeTracker.splice(this.internalTimeTracker.indexOf(tracking), 1)

      this.validate(true)
    },
    yearRequirementMessage: function(years, label) {
      if (label)
        return 'You must provide at least ' + years + ' years of ' + label + '.'
      else return 'You must provide at least ' + years + ' years.'
    }
  },
  updated: function() {
    this.$root.$emit('slider:update')
  },
  created: function() {
    if (!this.data.Body) this.$set(this.data, 'Body', [])
    if (this.data.Id == 'smart1003_borrower_residences')
      this.$set(
        this.data,
        'CustomError',
        '2 years of residence history required'
      )
    else if (this.data.Id == 'smart1003_borrower_employers')
      this.$set(
        this.data,
        'CustomError',
        '2 years of employment history required'
      )

    this.$store.commit('addInput', {
      field: this.data,
      sectionid: this.sectionid,
      pageid: this.pageid
    })

    // Multiple subsequent fields fix
    if (this.data.SubsequentFields && this.data.SubsequentFields.length > 1) {
      console.log(
        'Warning: Created filler Field Group in Subsequent Fields for ' +
          this.data.Id +
          '.'
      )
      // Put fields into rows
      let newFields = []
      for (let i = 0; i < this.data.SubsequentFields.length; i++) {
        let currField = this.data.SubsequentFields[i]
        currField.FieldSpan = 4
        newFields.push([
          currField
        ])
      }
      this.data.SubsequentFields = [
        {
          Id: this.data.SubsequentFields[0].Id + '__group',
          Type: 7,
          Fields: newFields
        }
      ]
    }

    this.$root.$on('borrower:change', () => {
      var currentIndexes = []
      var newIndexes = []

      // Get indexes of current items from body IDs
      for (var i = 0; i < this.data.Body.length; i++) {
        var parts = ((this.data.Body[i] || {}).Id || '').split('__')
        if (parts.length > 1)
          currentIndexes.push(parts[1] * 1)
        else
          currentIndexes.push('')
      }

      // Get indexes of new items from data store
      var indexedItem = {}
      if (Array.isArray(this.data.SubsequentFields) && this.data.SubsequentFields.length > [0])
        indexedItem = this.data.SubsequentFields[0]
      while (indexedItem.Type === 7 && ((indexedItem.Fields || []).length || 0) > 0)
        indexedItem = indexedItem.Fields[0]
      while (Array.isArray(indexedItem))
        indexedItem = indexedItem[0]

      var suffix = ''
      if (indexedItem.Type === 6)
        suffix = '__address_1'

      if (this.$store.state.saveData[this.$store.state.borrowerid].hasOwnProperty(indexedItem.Id + suffix))
        newIndexes.push('')

      for (var i = 0; i < 64; i++) {
        if (this.$store.state.saveData[this.$store.state.borrowerid].hasOwnProperty(indexedItem.Id + '__' + i + suffix))
          newIndexes.push(i)
      }

      // Remove index if not in newIndexes
      for (var i = currentIndexes.length - 1; i >= 0; i--) {
        if (currentIndexes[i] === '')
          continue
        if (newIndexes.indexOf(currentIndexes[i]) === -1)
          this.removeItem(i)
      }
      // Add index if not in currentindexes
      for (var i = 0; i < newIndexes.length; i++) {
        if (newIndexes[i] === '')
          continue
        if (currentIndexes.indexOf(newIndexes[i]) === -1)
          this.addItem(null, newIndexes[i]) 
      }

      var vm = this
      vm.$nextTick(function () {
        vm.validate(true)
      })
    })

    this.$root.$on('form:update', () => {
      // Not sure what this event does
    })

    this.$root.$on('form:validate', this.validate)
    this.$root.$on('form:validate-force', this.validate)
  },
  destroyed: function() {
    this.$store.commit('removeInput', {
      field: this.data,
      sectionid: this.sectionid,
      pageid: this.pageid
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.field-repeating-group {
  &.container {
    width: $card-container-width;
  }

  .repeating-group-item {
    border: solid 1px $medium-gray;
    margin-top: 4px;
    margin-bottom: 4px;
    border-radius: 4px;
    overflow: hidden;
    &.active {
      padding-bottom: 10px;
      .repeating-group-accordian {
        .repeating-group-label {
          &:after {
            position: absolute;
            bottom: 1px;
            left: 50%;
            transform: translateX(-50%);
            content: '';
            width: 99%;
            height: 1px;
            background: $medium-gray;
          }
        }
      }
      .repeating-group-field {
        position: relative;
        opacity: 1;
        pointer-events: auto;
        //max-height: 100vh;
        max-height: 750px;
        margin: 0 auto;
        width: 95%;
        max-width: 85rem;
        transition: max-height 0.35s;
        .repeating-group-remove {
          width: 100%;
          text-align: right;
          padding-top: 4px;
          margin-bottom: -10px;
          .svg-inline--fa {
            cursor: pointer;
          }
        }
      }
    }
    .repeating-group-accordian {
      &.container {
        width: $card-container-width;
      }
      .repeating-group-label {
        position: relative;
        padding: 16px 30px 16px 10px;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        background-color: $light;
        border-radius: 4px;
        .svg-inline--fa {
          position: absolute;
          right: 10px;
          top: calc(50% - 8px);
          pointer-events: none;
        }
      }
    }
    .repeating-group-field {
      pointer-events: none;
      opacity: 0;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.35s;
      //transition: none;
    }
  }
  .repeating-group-add-link {
    text-align: right;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

.field-screen-body {
  &.container {
    .container {
      width: unset;
    }
  }
}
</style>
